import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { failed, success } from "../../common/Toastify";
import Table from "react-bootstrap/Table";
import { Skeleton, TableCell, Tooltip } from "@mui/material";
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import { Link, useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import EditIcon from "../../../assets/images/edit.png";
import DeleteIcon from "../../../assets/images/delete.png";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { editHCNAuthority, getHCNAuthorityList } from "../../api/HCN";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import SelectFiled from "../../common/textfield/SelectFiled";

function HCNList() {
  const [HCNList, setHCNList] = useState([]);
  const { getConfirmation } = useConfirmDialog();
  const [organizations, setOrganizations] = useState([]);
  const orgId = useSelector(
    (state) => state?.auth?.user?.organizations?.[0]?.id
  );
  const [selectedOrgId, setSelectedOrgId] = useState(orgId);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const totalRows = HCNList?.length;
  const navigate = useNavigate();

  const onSuccessOrg = (data) => {
        setOrganizations(data?.map((org) => (org = { ...org, value: org.id })));
      };
  useOrgQuery({ onSuccess: onSuccessOrg });

  const fetchHCNList = () => {
    setIsLoading(true);
    getHCNAuthorityList(selectedOrgId)
      .then((res) => {
        if (res?.status === true) {
          setHCNList(res?.data);
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchHCNList();
  }, []);

  const handleDeleteClick = async (data) => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      data,
      actionBtnTitle: "Disable",
      message: `Are you sure you would like to Disable ${data?.display}?`,
    });
    if (confirmed) {
      setIsLoading(true);
      let payload = {
        active: false,
        authority: data?.authority, 
        description: data?.description,
        display: data?.display,
      };

      editHCNAuthority(data?.orgId, data.id, payload)
        .then((res) => {
          if (res?.status === true) {
            success(res?.message); 
          }
        })
        .catch((res) => {
          failed(res?.message);
        })
        .finally(() => {
          fetchHCNList();
        });
    }
  };

  const handleOrgChange = (event) => { 
      let value = event?.target?.value;
      setSelectedOrgId(value); 
  };
  useEffect(() => {
  fetchHCNList();
}, [selectedOrgId]);

  return (
    <section className="common-listing">
      <div className="heading-wrap h-change">
        <div className="heading-wrap mb-3">
           <form className="common-form border-fields dropdown-filter-rw d-flex align-items-center">
              {organizations.length > 1 && (
                <SelectFiled
                  keyField={"orgId"}
                  label={"Select Organization"}
                  options={organizations}
                  hideRequired={true}
                  onChange={handleOrgChange}
                  value={selectedOrgId}
                />
              )}
          </form>
        </div>
        <div className="right-wrap" style={{ margin: "left" }}>
          <Link
            variant="primary"
            to="/app/create-hcn-authority"
            className="custom-btn"
            title="Create HCN Authority"
            style={{ width: "auto" }}
          >
            {" "}
            + Create HCN Authority{" "}
          </Link>
        </div>
      </div>
      <div className="table-wrap">
        <Table responsive>
          <thead>
            <tr>
              <th>Display Name</th>
              <th>Authority</th>
              <th>Description</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              [1, 2, 3, 4]?.map((val) => (
                <tr key={val}>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                </tr>
              ))
            ) : HCNList?.length > 0 ? (
              HCNList?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )?.map((data) => {
                return (
                  <tr key={data?.id}>
                    <td className="name-text">{data?.display}</td>
                    <td className="name-text">{data?.authority}</td>
                    <td className="name-text">{data?.description}</td>
                    <td>
                      <div className="action-wrap">
                        <Tooltip title={"Edit"}>
                          <Link
                            to={`/app/edit-hcn-authority?hcnId=${data?.id}&orgId=${data?.orgId}`}
                            variant="primary"
                            className="success-btn"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </Link>
                        </Tooltip>

                        <Tooltip title={"Disable"}>
                          <Link
                            to=""
                            variant="primary"
                            onClick={() => handleDeleteClick(data)}
                            className="delete-btn"
                            style={{ opacity: "1" }}
                          >
                            <img src={DeleteIcon} alt="Disable" />
                          </Link>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <TableCell colSpan="5" style={{ textAlign: "center" }}>
                  No Data Available
                </TableCell>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {HCNList?.length > 0 ? (
        <CustomPagination
          tableData={HCNList}
          totalRows={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          handlePage={(pageNo) => setPage(pageNo)}
        />
      ) : null}
    </section>
  );
}

export default HCNList;
